// vendor
import { Injectable } from '@angular/core';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.state';

// local application
import { TimesheetService } from 'app/services/timesheet.service';
import { TimesheetTypes } from './timesheet.type';
import * as timesheetActions from './timesheet.action';
import { DialogActions } from 'app/store/global/dialog';
import { ClockOutModel } from './timesheet.model';

@Injectable()
export class TimesheetEffects {
  constructor(
    private actions$: Actions,
    private service: TimesheetService,
    private store: Store<AppState>
  ) {}

  postClockIn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TimesheetTypes.POST_CLOCK_IN),
      switchMap(({ payload }) =>
        this.service.clockIn(payload).pipe(
          map(({ data }) => {
            this.store.dispatch(timesheetActions.getTimesheetLogs());
            return timesheetActions.clockInSuccess(data);
          }),
          takeUntil(
            this.actions$.pipe(ofType(TimesheetTypes.POST_CLOCK_IN_SUCCESS))
          ),
          catchError((error: unknown) => {
            this.store.dispatch(timesheetActions.clockInCancel());
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );

  postClockOut$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TimesheetTypes.POST_CLOCK_OUT),
      switchMap(({ payload }: any) => {
        return this.service.clockOut(payload).pipe(
          map((data) => {
            this.store.dispatch(
              DialogActions.showSuccessNotificationDialogAction(data)
            );
            return timesheetActions.clockOutSuccess(data);
          }),
          takeUntil(
            this.actions$.pipe(ofType(TimesheetTypes.POST_CLOCK_OUT_SUCCESS))
          ),
          catchError((error: unknown) => {
            this.store.dispatch(timesheetActions.clockOutCancel());
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        );
      })
    )
  );

  timeLogs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TimesheetTypes.GET_TIMESHEET_LOGS),
      switchMap(() =>
        this.service.timesheetLogs().pipe(
          map(({ data }) => {
            return timesheetActions.getTimesheetLogsSuccess(data.details);
          }),
          takeUntil(
            this.actions$.pipe(
              ofType(TimesheetTypes.GET_TIMESHEET_LOGS_SUCCESS)
            )
          ),
          catchError((error: unknown) => {
            this.store.dispatch(timesheetActions.getTimesheetLogsCancel());
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );

  upload$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TimesheetTypes.File_Upload),
      switchMap(({ payload }) =>
        this.service.upload(payload).pipe(
          map(({ data }) => {
            return timesheetActions.fileUploadSuccessAction(data.file_data);
          }),
          takeUntil(
            this.actions$.pipe(ofType(TimesheetTypes.File_Upload_Success))
          ),
          catchError((error: unknown) => {
            this.store.dispatch(timesheetActions.fileUploadFailedAction(error));
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );
}
